export const REFERRER_STRIP_REGEX = /([\?|\&]+__hstc|[\?|\&]+utm_tags)/;
export const DEFAULT_SUPPORT_COUNTRIES = ['mx', 'co', 'cl'] as const;

export const BASE_URL_BR = 'https://www.nuvemshop.com.br';
export const BASE_URL_LATAM = 'https://www.tiendanube.com';
